import {reqWithToken} from './requestHelper';

export async function getStudentsWithFilter(filter){
    return (await reqWithToken('api/studentInfoQuerySystem/studentInfo',{
        data:{...filter},
        method:'POST'
    })).data;
}